import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

// Cria a instância de axios apontando para o endpoint de consultas
const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/ControleConsultasRmc');

export default class ConsultaService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarPorPromotoraEmpregador(
    idPromotora: number,
    idEmpregador: number,
    page: number = 0,
    size: number = 10,
    dataInicial: string,
    dataFinal: string
  ) {
    return await this.axios.get(`/listarControleConsultasRmc`, {
      params: { idPromotora, idEmpregador, dataInicial, dataFinal, page, size },
    });
  }

  async listarTodosPaginados(page: number = 0, size: number = 10, sort: string = 'data,desc') {
    return await this.axios.get(`/todos`, {
      params: { page, size, sort },
    });
  }
}
